import { MenuItem, SxProps, TextField } from '@mui/material'
import { useEffect, useState } from 'react'
import { CustomAutocomplete } from '../../../../components/Common/input/CustomInput'

// extends Autocomplete props
interface DesplegableRubrosProps {
  onChange?: (rubro: any) => void
  handleFormSubmit?: () => void
  hideLabel?: boolean
  label?: any
  placeHolder?: string
  disabled?: boolean
  fullWidth?: boolean
  sx?: SxProps
  rubros: any[]
  defaultValue?: any
  value?: any
}

const DesplegableRubros = ({
  onChange,
  handleFormSubmit,
  disabled,
  fullWidth,
  label,
  hideLabel,
  placeHolder,
  rubros,
  sx,
  defaultValue,
  value
}: DesplegableRubrosProps) => {
  const isControlled = value !== undefined
  const [selectedRubro, setSelectedRubro] = useState<any>(
    rubros?.find((rubro) => rubro.codRubro === defaultValue) || null
  )

  useEffect(() => {
    if (defaultValue) {
      setSelectedRubro(rubros?.find((rubro) => rubro.codRubro === defaultValue) || null)
    }
  }, [defaultValue, rubros])

  return (
    <CustomAutocomplete
      options={rubros}
      getOptionLabel={(rubro: any) => rubro.nombreAnalytics || rubro.nombre || ''}
      onChange={(e: any, rubro: any) => {
        if (onChange) onChange(rubro)
        if (!isControlled) {
          setSelectedRubro(rubro || null)
        }
      }}
      fullWidth={fullWidth}
      disabled={disabled}
      value={isControlled ? value : selectedRubro}
      sx={sx}
      renderInput={(params) => (
        <TextField
          {...params}
          onKeyDown={(e) => e.key === 'Enter' && handleFormSubmit && handleFormSubmit()}
          label={label ? label : ''}
          placeholder={hideLabel || !label ? (placeHolder ? placeHolder : 'Todos') : ''}
          variant="outlined"
        />
      )}
      renderOption={(props, rubro: any) => (
        <MenuItem {...props} value={rubro.codRubro} key={rubro.codRubro || rubro.codigo}>
          {rubro.nombreAnalytics || rubro.nombre}
        </MenuItem>
      )}
    />
  )
}

export default DesplegableRubros
